<template lang="pug">
  yz-card-text(:style="backgroundColor" :class="classes")
    slot
</template>

<script>
import {getParentClasses, hasPaddingClasses} from "@/utils";

export default {
  name: 'YzDialogFullscreenContent',
  props: {
    color: {
      type: String,
      default: '#F8F8F8'
    },
  },
  computed: {
    classes() {
      const parentClass = getParentClasses(this.$vnode)

      if (hasPaddingClasses(parentClass)) {
        return ''
      }
      return `pa-6 ${parentClass}`.trim()
    },
    backgroundColor() {
      const style = {}

      if (this.color.startsWith('#')) {
        style.backgroundColor = this.color
      } else if (this.color.startsWith('yz-')) {
        style.backgroundColor = `var(--${this.color})`
      } else {
        style.backgroundColor = `var(--yz-${this.color})`
      }

      return style
    }
  }
}
</script>

<style lang="scss" scoped>
</style>